import React from "react";
import { Phone, ArrowRight, Clock2 } from "lucide-react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HowardCountyHero() {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "HomeAndConstructionBusiness",
      "@id": "https://triserveinc.com/#business",
      name: "TriServe",
      telephone: "855-435-6631",
      areaServed: {
        "@type": "AdministrativeArea",
        name: "Howard County, MD"
      }
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#water-damage",
      name: "Water Damage & Flood Restoration",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Howard County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#sewage-cleanup",
      name: "Sewage Backup Cleanup",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Howard County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#fire-restoration",
      name: "Fire & Smoke Damage Restoration",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Howard County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#mold-remediation",
      name: "Mold Remediation",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Howard County, MD"
    }, {
      "@type": "BreadcrumbList",
      "@id": "https://triserveinc.com/#breadcrumb",
      itemListElement: [{
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://triserveinc.com/"
      }, {
        "@type": "ListItem",
        position: 2,
        name: "Maryland",
        item: "https://triserveinc.com/MarylandPage"
      }, {
        "@type": "ListItem",
        position: 3,
        name: "Howard County"
      }]
    }]
  };
  return <section id="howardcountyhero" data-nav="light" className="relative bg-background text-foreground overflow-hidden py-16 sm:py-20 lg:py-28 border-b border-border isolate">
      {/* Decorative ambient background accents */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute top-1/2 right-[-10%] h-[28rem] w-[28rem] rounded-full bg-secondary/5 blur-3xl" />
      </div>

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLdData)
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Breadcrumb Trail */}
        <div className="mb-6 sm:mb-8">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/MarylandPage">Maryland</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Howard County</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Hero Content */}
        <div className="flex flex-col items-start text-left">
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/50 px-3.5 py-1.5 text-xs sm:text-sm font-medium text-muted-foreground mb-6">
            <Clock2 className="size-4 text-primary shrink-0" />
            <span>24/7 Direct Crew Response</span>
          </div>

          <h1 className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.15] max-w-4xl">
            Howard County Water, Fire & Mold Restoration Services by TriServe
          </h1>

          <p className="mt-5 sm:mt-6 text-base sm:text-lg lg:text-xl text-muted-foreground leading-relaxed max-w-3xl">
            Local restoration technicians available 24/7 for immediate on-site response across Columbia, Ellicott City, Clarksville, and all of Howard County.
          </p>

          {/* Action CTAs */}
          <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-3.5 sm:gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-semibold text-base px-6 h-12">
              <a href="tel:8554356631">
                <Phone className="size-4 shrink-0" />
                <span>Call Now: 855-435-6631</span>
              </a>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-border bg-card hover:bg-accent text-foreground font-semibold text-base px-6 h-12">
              <Link to="/ContactRequestServicePage">
                <span>Request Service</span>
                <ArrowRight className="size-4 shrink-0" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}